import { Component, Input, OnInit } from '@angular/core';

import { WebItem } from 'src/app/core/models/api/web-item.model';

@Component({
    selector: 'app-cards-top-image-list',
    templateUrl: './cards-top-image-list.component.html',
    styleUrls: ['./cards-top-image-list.component.scss']
})
export class CardsTopImageListComponent implements OnInit {

    @Input() items: WebItem[];

    constructor() { }

    ngOnInit() { }

    getRowClass() : string {
        
        var parentClass = '';

        var itemsCount = this.items.length;

        if (itemsCount > 0) {

            switch(itemsCount) {
                case 2:  parentClass = "col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 my-2"; break; 
                case 3:  parentClass = "col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4 my-2"; break;
                case 4:  parentClass = "col-12 col-sm-12 col-md-6  col-lg-3 col-xl-3 col-xxl-3 my-2"; break;
                case 6:  parentClass = "col-12 col-sm-12 col-md-6  col-lg-2 col-xl-2 col-xxl-2 my-2"; break;
                case 12: parentClass = "col-12 col-sm-12 col-md-6  col-lg-1 col-xl-1 col-xxl-1 my-2"; break;
            }

        }
        
        return parentClass;
        
    }
    
}
